
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("5DmW5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;
// ====================================================================================
// donation.module
// ====================================================================================
var $41a262e1a3b77bd9$var$donations = document.querySelectorAll(".donation-func");
var $41a262e1a3b77bd9$var$convertToFloating = function convertToFloating(value) {
    return parseFloat(value.replace(",", "."));
};
var $41a262e1a3b77bd9$var$init = module.exports.init = function init() {
    var attempts = 0;
    // if document.ready needed
    var _whenComplete = function whenComplete() {
        if (++attempts > 30) return;
        if (document.readyState === "complete") $41a262e1a3b77bd9$var$donations.forEach(function(donation) {
            var submit = donation.querySelector(".btn");
            var formData = new FormData(donation);
            var data = donation.dataset;
            var radio = formData.get("tw_amount_radio");
            var input = formData.get("tw_amount_input");
            donation.addEventListener("keydown", function(event) {
                if (event.keyCode == 13) {
                    event.preventDefault();
                    return false;
                }
            });
            submit.addEventListener("click", function(e) {
                e.preventDefault();
                formData = new FormData(donation);
                radio = formData.get("tw_amount_radio");
                input = formData.get("tw_amount_input");
                var amount = 0.0;
                if (radio !== null) amount = radio;
                if (data.placeholder !== undefined) {
                    var ph = $41a262e1a3b77bd9$var$convertToFloating(data.placeholder);
                    amount = ph * data.conv;
                }
                if (input !== null && input !== "") amount = input * data.conv;
                donation.querySelector("input[name=tw_amount]").value = amount;
                donation.submit();
            });
        });
        else setTimeout(function() {
            _whenComplete();
        }, 400);
    };
    _whenComplete();
};

});


//# sourceMappingURL=donation.module.cd4ee0d3.js.map
